import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'next-themes';
import { LangProvider } from './lib/i18n';

import App from './App';

import './index.css';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

createRoot(document.getElementById('root')!).render(
  <LangProvider>
    <ThemeProvider 
      attribute="data-theme" 
      themes={["aurora", "onyx"]} 
      defaultTheme="aurora" 
      enableSystem={false} 
      storageKey="tobius-theme"
    >
      <App />
    </ThemeProvider>
  </LangProvider>
);
